import styled, { css } from 'styled-components'

// Components
import { ReactComponent as BaseVatCheckmark } from 'icons/checkmark-circle-filled-12.svg'
import { ReactComponent as BaseVatClock } from 'icons/clock-circle-filled-12.svg'
import { ReactComponent as BaseVatExclamation } from 'icons/exclamation-circle-filled-12.svg'

export const VatIconStyle = css`
  width: 12px;
  margin-left: 7px; /* stylelint-disable-line scales/space */
  margin-right: 7px; /* stylelint-disable-line scales/space */
`

export const VatWrapper = styled.div`
  display: flex;
  align-items: center;
`

const VatError = css`
  color: ${({ theme }) => theme.colors.red};
`

export const VatCheckmark = styled(BaseVatCheckmark)`
  ${VatIconStyle};
  color: ${({ theme }) => theme.colors.primaryTint[100]};
`

export const VatClock = styled(BaseVatClock)`
  ${VatIconStyle};
  color: ${({ theme }) => theme.colors.gray};
`

export const VatExclamation = styled(BaseVatExclamation)`
  ${VatIconStyle};
  ${VatError};
`

export const VatValue = styled.span<{ status: 'UNVERIFIED' | any }>`
  color: ${({ status }) => (status === 'UNVERIFIED' ? '#999999' : 'inherit')};
`
export const VatErrorText = styled.span`
  ${VatError};
`
